export default __webpack_public_path__ + "static/media/img-monochrome-logo-text.b08e6e41.jpg";